<div class="modal-body">
  <div class="content" *ngIf="!loading.providers">
    <div class="content__top">
      <h4 translate>company.dids.update-provider.popup.title</h4>
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <i class="icon-small-close"></i>
      </button>
    </div>
    <div class="content__form" [formGroup]="form">
      <div class="form-group">
        <label for="replace-did-provider" translate>company.dids.replace-with-existing-did.popup.form.provider.label</label>
        <gdp-select-provider formControlName="provider" [providers]="availableProviders"></gdp-select-provider>
      </div>
      <div class="form-group">
        <label for="replace-did-provider-reference" translate>company.dids.replace-with-existing-did.popup.form.provider-reference.label</label>
        <div class="vox-input-group vox-input-group_dense" [ngClass]="{
          'vox-input-group_invalid': isFieldValid('providerReference')}">
            <input class="vox-text-field" type="text" id="replace-did-provider-reference"
                formControlName="providerReference"
                [placeholder]="'company.dids.replace-with-existing-did.popup.form.provider-reference.placeholder' | translate"><i
                class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
                class="vox-input-group__error-message"
                translate>company.dids.replace-with-existing-did.popup.form.error.required</span>
        </div>
      </div>
      <div class="submit-container">
        <button class="vox-btn vox-btn-primary" type="submit"
          (click)="onSubmit()"
          [disabled]="form.invalid"
          [ladda]="loading.submit" data-style="zoom-in" data-spinner-color="#fff">
            <span translate>company.dids.replace-with-existing-did.popup.form.save</span>
        </button>
      </div>
    </div>
  </div>
  <div class="content" *ngIf="loading.providers">
    <ngx-skeleton-loader [theme]="{ 'height': '500px', 'margin-bottom': 0, 'outline': '0px' }"></ngx-skeleton-loader>
  </div>
</div>
